import React from 'react'
import EnterpriseContractTable from './table'

import { withRouter } from 'react-router-dom'

import {
  Card
} from 'antd'

class EnterpriseContracts extends React.Component {
  render() {
    console.log(this.props.router)
    return (
      <div>
        <Card
          style={{ margin: 12 }}
          title="To All Enterprises"
        >
          <EnterpriseContractTable
            allEnterpriseFlag
          />
        </Card>
        <Card
          title="Specific Enterprise"
        >
          <EnterpriseContractTable/>
        </Card>
      </div>
    )
  }

  componentDidMount() {

  }
}

export default withRouter(EnterpriseContracts) 


// WEBPACK FOOTER //
// ./src/components/enterprise/contract/index.js